import { render, staticRenderFns } from "./merchants_propbk.vue?vue&type=template&id=3422443c&scoped=true"
import script from "./merchants_propbk.vue?vue&type=script&lang=js"
export * from "./merchants_propbk.vue?vue&type=script&lang=js"
import style0 from "./merchants_propbk.vue?vue&type=style&index=0&id=3422443c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3422443c",
  null
  
)

export default component.exports